import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  locale = 'en';
  translations = {
    
      "Hall of fame":{
         "en":"Hall of fame",
         "de":"Ruhmeshalle",
         "hu":"Eredmények",
         "nl":"Eregalerij",
         "fr":"Palmarès",
         "es":"Salón de la fama"
      },
      "Maximum number of players reached":{
         "en":"Maximum number of players reached",
         "de":"Maximale Spieleranzahl erreicht",
         "hu":"A maximális játékos szám elérve",
         "nl":"Maximaal aantal spelers bereikt",
         "fr":"Nombre de joueurs maximum atteint",
         "es":"Número máximo de jugadores alcanzado"
      },
      "Image successfully uploaded":{
         "en":"Image uploaded successfully",
         "de":"Bild erfolgreich hochgeladen",
         "hu":"Kép sikeresen feltöltve",
         "nl":"Afbeelding succesvol geüpload",
         "fr":"Image téléchargée avec succès",
         "es":"Imagen subida con éxito"
      },
      "You can throw a bomb on a random player.":{
         "en":"You can throw a bomb on a random player. This means that a randomly selected player gets half a point for a correct answer to the next question.",
         "de":"Sie können eine Bombe per Zufallsgenerator werfen.",
         "hu":"Bombát dobhatsz egy véletlenszerűen kiválasztott játékosra. A bomba hatása, hogy a következő helyes válasz esetén a játékos csupán fele annyi pontot szerez.",
         "nl":"Je kunt een bom op een willekeurig team gooien.",
         "fr":"Vous pouvez lancer une bombe sur un joueur au hasard.",
         "es":"Puedes lanzar una bomba a un jugador al azar. Esto significa que el jugador seleccionado obtendrá la mitad de puntos en el siguiente reto."
      },
      "You just activated the bomb perk.":{
         "en":"You just activated the bomb perk.",
         "de":"Du hast gerade den Effekt \"Bombe\" aktiviert.",
         "hu":"Aktiváltad a bombát!",
         "nl":"Je hebt zojuist de bom geactiveerd.",
         "fr":"Vous venez d'activer l'effet bombe.",
         "es":"Acabas de activar el beneficio de bomba."
      },
      "Bomb perk active. Half points at next question.":{
         "en":"You just activated the bomb perk.",
         "de":"Bombenvorteil aktiv. Halbe Punkte bei der nächsten Frage.",
         "hu":"Bomba aktív! Fél pont a következő kérdésnél.",
         "nl":"Bom actief. Halve punten bij volgende vraag.",
         "fr":"Vous avez reçu une bombe. Moitié des points à la prochaine question.",
         "es":"Has recibido una bomba. Mitad de puntos en el siguiente reto."
      },
      "No other players to use this perk on.":{
         "en":"No other players to use this perk on.",
         "de":"Keine anderen Spieler, bei denen dieser Effekt verwendet werden kann.",
         "hu":"Nincs más játékos a játékban, akin alkalmazni tudnád ezt a funkciót.",
         "nl":"Geen andere spelers om deze tool te gebruiken.",
         "fr":"Pas d'autre joueur sur lequel cet effet peut être utilisé.",
         "es":"No hay otros jugadores en los que usar este beneficio."
      },
      "Freeze":{
         "en":"Freeze",
         "de":"Einfrieren",
         "hu":"Fagyasztás",
         "nl":"Bevriezen",
         "fr":"Geler",
         "es":"Congelar"
      },
      "Free":{
         "en":"Free",
         "de":"Kostenlos",
         "hu":"Ingyenes",
         "nl":"Gratis",
         "fr":"Gratuit",
         "es":"Gratis"
      },
      "Bomb":{
         "en":"Bomb",
         "de":"Bomb",
         "hu":"Bomba",
         "nl":"Bom",
         "fr":"Bombe",
         "es":"Bomba"
      },
      "Blank map":{
         "en":"Blank map",
         "de":"Leere Karte",
         "hu":"Vaktérkép",
         "nl":"Lege kaart",
         "fr":"Carte vide",
         "es":"Mapa en blanco"
      },
      "Photo gallery":{
         "en":"Take photos",
         "de":"Fotogallerie",
         "hu":"Készíts fotót",
         "nl":"Fotogalerij",
         "fr":"Photos",
         "es":"Tomar fotos"
      },
      "freeze":{
         "en":"Freeze",
         "de":"Einfrieren",
         "hu":"Fagyasztás",
         "nl":"Bevriezen",
         "fr":"Geler",
         "es":"Congelar"
      },
      "bomb":{
         "en":"Bomb",
         "de":"Bomb",
         "hu":"Bomba",
         "nl":"Bom",
         "fr":"Bombe",
         "es":"Bomba"
      },
      "photo":{
         "en":"Take photos",
         "de":"Fotogallerie",
         "hu":"Fotó galéria",
         "nl":"Foto",
         "fr":"Photos",
         "es":"Fotos"
      },
      "map_tap":{
         "en":"Teleport",
         "de":"Teleport",
         "hu":"Teleport",
         "nl":"Teleporteer",
         "fr":"Teleport",
         "es":"Teletransporte"
      },
      "Freeze perk will freeze all other players for 30 seconds.":{
         "en":"Freeze perk will freeze all other players for 30 seconds.",
         "de":"Freeze Perk friert alle anderen Spieler für 30 Sekunden ein.",
         "hu":"A fagyasztás funkció 30 másodpercig fagyasztja a többi játékost.",
         "nl":"Dit bevriest alle andere teams gedurende 30 seconden.",
         "fr":"L'effet Congel' fige 30 secondes tous les autres joueurs.",
         "es":"El beneficio de congelación congelará a todos los demás jugadores durante 30 segundos."
      },
      "You can take photos during the game.":{
         "en":"You can take photos during the game.",
         "de":"Sie können während des Spiels Fotos machen.",
         "hu":"A fotót itt tudod majd beküldeni.",
         "nl":"Tijdens het spel kun je foto's maken.",
         "fr":"Vous pouvez prendre des photos pendant le jeu.",
         "es":"Puedes tomar fotos durante el juego."
      },
      "You just activated the photo perk.":{
         "en":"You just activated the photo perk.",
         "de":"Sie haben gerade den Foto Effekt eingesetzt",
         "hu":"Aktiváltad a fotó funkciót!",
         "nl":"Je hebt zojuist de foto tool geactiveerd.",
         "fr":"Vous venez d'activer l'effet photo.",
         "es":"Acabas de activar el beneficio de foto."
      },
      "Blank map perk is active for 30 seconds.":{
         "en":"Blank map perk is active for 30 seconds.",
         "de":"Der Spezialeffekt „Leere Karte“ ist 30 Sekunden lang aktiv.",
         "hu":"Vaktérkép aktív 30 másoedpercig.",
         "nl":"Opengespat ei is 30 seconden actief.",
         "fr":"Effet carte vide activé 30 secondes",
         "es":"El beneficio de mapa en blanco está activo durante 30 segundos."
      },
      "It will change the map style to a blank map for other players for 30 seconds.":{
         "en":"It will change the map style to a blank map for other players for 30 seconds.",
         "de":"Der Kartenstil wird für andere Spieler 30 Sekunden lang in eine leere Karte geändert.",
         "hu":"A térkép stílusát 30 másodpercig vaktérképpé változtatja.",
         "nl":"Deze tool verandert de kaartstijl gedurende 30 seconden in een blanco kaart voor andere teams.",
         "fr":"La carte apparaitra vide 30 secondes pour les autres joueurs.",
         "es":"Cambiará el estilo del mapa a un mapa en blanco para otros jugadores durante 30 segundos."
      },
      "PIN to join the game: ":{
         "en":"PIN to join the game: ",
         "de":"PIN, um dem Spiel beizutreten:  ",
         "hu":"Játék PIN",
         "nl":"PIN om mee te doen aan het spel",
         "fr":"PIN pour se connecter au jeu : ",
         "es":"PIN para unirse al juego: "
      },
      "Position updated!":{
         "en":"Position updated!",
         "de":"Position aktualisiert.",
         "hu":"Pozíció frissítve",
         "nl":"Positie bijgewerkt!",
         "fr":"Position mise à jour !",
         "es":"¡Posición actualizada!"
      },
      "What is the goal of the game?":{
         "en":"What is the goal of the game?!",
         "de":"Was ist das Ziel des Spiels?",
         "hu":"Mi a játék célja?",
         "nl":"Wat is het doel van het spel?",
         "fr":"Quel est le but du jeu ?",
         "es":"¿Cuál es el objetivo del juego?"
      },
      "To collect all the story points":{
         "en":"To collect all the story points",
         "de":"Erreiche alle Wegpunkte und gewinne Punkte.",
         "hu":"Valamennyi kérdés megválaszolása",
         "nl":"Om alle verhaalpunten te verzamelen",
         "fr":"Trouvez tous les marqueurs et gagnez plein de points !",
         "es":"Recoger todos los marcadores y recibir muchos puntos"
      },
      "To wait until the time is up":{
         "en":"To wait until the time is up",
         "de":"Warte bis die Zeit um ist.",
         "hu":"Megvárni ameddig letelik az idő",
         "nl":"Om te wachten tot de tijd om is",
         "fr":"Attendre la fin du jeu",
         "es":"Esperar hasta que se acabe el tiempo"
      },
      "To stay outside the battle circle":{
         "en":"To stay outside the battle circle",
         "de":"Innerhalb des Kreises (der Battle Arena) bleiben. ",
         "hu":"Kimaradni a harci körből",
         "nl":"Om buiten de strijdcirkel te blijven",
         "fr":"Rester en dehors du cercle",
         "es":"Mantenerse fuera del círculo de batalla"
      },
      "Don't forget to use the 'Refresh my position' button regularly to refresh your current location in the game.":{
         "en":"Don't forget to use the 'Refresh my position' button regularly to refresh your current location in the game.",
         "de":"Schaltfläche \"Position aktualisieren\" regelmässig klicken, um Standort im Spiel zu aktualisieren.",
         "hu":"Ne nefejtsd el haszánli a 'Pozícióm frissítése' gombot, mivel ezzel frissíted helyzetedet a térképen.",
         "nl":"Vergeet niet regelmatig de knop 'Vernieuw mijn positie' te gebruiken om je huidige locatie in het spel te vernieuwen.",
         "fr":"N'oubliez pas d'utiliser régulièrement le bouton Actualiser ma position pour rafraîchir votre position !",
         "es":"¡No olvides usar el botón 'Actualizar mi posición' regularmente para refrescar tu ubicación actual en el juego!"
      },
      "Hurry up, only ":{
         "en":"Hurry up, only ",
         "de":"Beeilung, nur ",
         "hu":"Siess, már csak ",
         "nl":"Schiet op, er resteren slechts",
         "fr":"Vite, il reste ",
         "es":"¡Date prisa, solo quedan "
      },
      " minutes left!":{
         "en":" minutes left!",
         "de":" Minuten übrig!",
         "hu":" perc maradt! ",
         "nl":" minuten!",
         "fr":"minutes !",
         "es":" minutos!"
      },
      "Got it":{
         "en":"Got it",
         "de":"Verstanden!",
         "hu":"Értettem ",
         "nl":"Ik snap het",
         "fr":"Compris !",
         "es":"¡Entendido!"
      },
      "Backpack item":{
         "en":"Backpack item",
         "de":"Spezialobjekt für Rucksack",
         "hu":"Hátizsták tárgy ",
         "nl":"Rugzakartikel",
         "fr":"Objet du sac à dos",
         "es":"Artículo de mochila"
      },
      "This item may help you to solve the final riddle.":{
         "en":"This item may help you to solve the final riddle.",
         "de":"Dieses Objekt kann helfen, das letzte Rätsel zu lösen.",
         "hu":"A tárgy segítségedre lehet megoldani a végső rejtélyt ",
         "nl":"Dit item kan je helpen om het laatste raadsel op te lossen.",
         "fr":"Cet objet peut vous aider à résoudre l'énigme finale.",
         "es":"Este artículo puede ayudarte a resolver el enigma final."
      },
      "Back":{
         "en":"Back",
         "de":"Zurück",
         "hu":"Vissza",
         "nl":"Annuleren",
         "fr":"Retour",
         "es":"Atrás"
      },
      "Next":{
         "en":"Next",
         "de":"Nächste",
         "hu":"Tovább",
         "nl":"Volgende",
         "fr":"Suivant",
         "es": "Siguiente"
      },
      "Congrats! You've activated the safehouse! Now find it on the map and reach it before it's too late!":{
         "en":"Congrats! You've activated the safehouse! Now find it on the map and reach it before it's too late!",
         "de":"Herzlichen Glückwunsch! Das Safehouse wurde aktiviert. Lokalisiere es auf der Karte und erreiche es, bevor es zu spät ist.",
         "hu":"Gratulálunk! Aktiváltad a \"safe house\"-t. Most keresd meg a térképen és érd el a lehető leggyorsabban!",
         "nl":"Proficiat! Je hebt het safehouse geactiveerd! Vind het nu op de kaart en bereik het voordat het te laat is!",
         "fr":"Félicitations, vous avez activé la Safehouse ! Trouvez-la sur la carte et allez-y avant qu'il ne soit trop tard !",
         "es":"¡Felicidades! ¡Has activado la casa segura! ¡Encuéntrala en el mapa y llega antes de que sea demasiado tarde!"
      },
      " is a fellow player in the musesum who scored ":{
         "en":" is a fellow player in the musesum who scored ",
         "de":" ist MitspielerIn im Museum und hat gepunktet ",
         "hu":" egy másik játékos a múzeumban, aki elért ",
         "nl":" is een medespeler. Die scoorde ",
         "fr":"est un autre joueur dans le musée qui a obtenu",
         "es":" es un compañero de juego en el museo que anotó "
      },
      " points so far.":{
         "en":" points so far.",
         "de":" Punkte bisher.",
         "hu":" pontot eddig.",
         "nl":" punten tot nu toe.",
         "fr":"points jusqu'ici",
         "es":" puntos hasta ahora."
      },
      " The player is still in the museum!":{
         "en":" The player is still in the museum!",
         "de":" Der Spieler ist immer noch im Museum!",
         "hu":" A játékos jelenleg is aktív.",
         "nl":"Het team nog steeds aan het spelen!",
         "fr":"Le joueur est encore dans le musée !",
         "es":" ¡El jugador todavía está en el museo!"
      },
      "You don't have enough points to use this perk.":{
         "en":"You don't have enough points to use this perk.",
         "de":"Zu wenig Punkte, um Spezialeffekt zu nutzen.",
         "hu":"Nincs elég pontod, hogy használd!",
         "nl":"Je hebt niet genoeg punten om deze tool te gebruiken.",
         "fr":"Vous n'avez pas assez de points pour utiliser cet effet.",
         "es":"No tienes suficientes puntos para usar este beneficio."
      },
      "Use perk":{
         "en":"Use perk",
         "de":"Spezialeffekt einsetzen",
         "hu":"Használom",
         "nl":"Gebruik tool",
         "fr":"Utiliser un effet",
         "es":"Usar beneficio"
      },
      "Double perk is active. You will receive doupled points at the next question if your answer is correct.":{
         "en":"Double perk is active. You will receive doupled points at the next question if your answer is correct.",
         "de":"Doppler-Effekt ist aktiv. Bei richtiger Beantwortung der nächsten Frage gibt es doppelte Punktzahl.",
         "hu":"A duplázás aktív. Dupla pontot kapsz, ha helyesen válaszolsz!",
         "nl":"Verdubbelaar is actief. Je krijgt dubbele punten bij de volgende vraag als je antwoord juist is.",
         "fr":"Effet-Double est activé. Vous doublez des points à la prochaine question si votre réponse est correcte.",
         "es":"El beneficio doble está activo. Recibirás puntos dobles en la siguiente pregunta si tu respuesta es correcta."
      },
      "Freeze perk is active. You frozed all other players for 30 seconds.":{
         "en":"Freeze perk is active. You froze all other players for 30 seconds.",
         "de":"Freeze Effekt ist aktiv. Die anderen Spieler wurden für 30 Sekunden eingefroren.",
         "hu":"Fagyasztás aktív. Lefagyasztottad az ellenfeleidet 30 másodpercre.",
         "nl":"Bevriezer is actief. Je bevriest alle andere teams gedurende 30 seconden.",
         "fr":"Effet Congel' est activé. Vous avec figé tous les autres joueurs pendant 30 secondes.",
         "es":"El beneficio de congelación está activo. Has congelado a todos los demás jugadores durante 30 segundos."
      },
      "Do you really want to end the game?":{
         "en":"Do you really want to end the game?",
         "de":"Soll das Spiel wirklich beendet werden?",
         "hu":"Biztosan szeretnéd befejezni a játékot?",
         "nl":"Wil je het spel echt beëindigen?",
         "fr":"Vous voulez vraiment quitter le jeu ?",
         "es":"¿Realmente quieres terminar el juego?"
      },
      "You cannot rejoin in the game if you hit 'End Game'":{
         "en":"You cannot rejoin in the game if you hit 'End Game'",
         "de":"Das Spiel kann nicht wieder betreten werden, wenn \"Spiel beenden\" geklickt wird.",
         "hu":"A játék véglegesen befejeződik a 'Játék befejezése' gombra kattintva",
         "nl":"Je kunt dit niet ongedaan maken.",
         "fr":"Vous ne pourrez plus rejoindre le jeu si vous cliquez sur Terminer le jeu",
         "es":"No puedes volver a unirte al juego si presionas 'Terminar juego'"
      },
      "End Game":{
         "en":"End Game",
         "de":"Spiel beenden",
         "hu":"Játék befejezése",
         "nl":"Spel beëindigen",
         "fr":"Terminer le jeu",
         "es":"Terminar juego"
      },
      "This QR code has been activated already":{
         "en":"This QR code has been activated already",
         "de":"Dieser QR-Code wurde bereits aktiviert",
         "hu":"Hoppá! Ezt a QR kódot már beolvastad.",
         "nl":"Deze QR-code is al geactiveerd",
         "fr":"Ce code QR a déjá été activé. ",
         "es":"Este código QR ya ha sido activado"
      },
      "Do you really want to launch the game?":{
         "en":"Do you really want to launch the game?",
         "de":"Spiel jetzt starten?",
         "hu":"Biztosan szeretnéd elindítani a játkot?",
         "nl":"Wil je het spel echt starten?",
         "fr":"Vous voulez vraiment lancer le jeu ?",
         "es":"¿Realmente quieres iniciar el juego?"
      },
      "The game will start for every other players by clicking \"Start game\"":{
         "en":"The game will start for every other players by clicking \"Start game\"",
         "de":"Das Spiel startet für alle SpielerInnen nach Klick auf \"Spiel starten\"",
         "hu":"A játék a \"Játék indítása\" gomb lenyomásával indul",
         "nl":"Zodra je klikt op \"Spel starten\", zal het spel voor iedereen van start gaan.",
         "fr":"Le jeu commencera pour tous les autres joueurs en cliquant sur Commencer le jeu",
         "es":"El juego comenzará para todos los demás jugadores al hacer clic en 'Iniciar juego'"
      },
      "PIN error":{
         "en":"PIN error",
         "de":"PIN-Fehler",
         "hu":"PIN hiba",
         "nl":"PIN-fout",
         "fr":"PIN erroné",
         "es":"Error de PIN"
      },
      "This PIN has expired":{
         "en":"This PIN has expired",
         "de":"Diese PIN ist abgelaufen",
         "hu":"A PIN lejárt",
         "nl":"Deze pincode is verlopen",
         "fr":"Ce PIN a expiré",
         "es":"Este PIN ha expirado"
      },
      "Wrong PIN":{
         "en":"Wrong PIN",
         "de":"Falsche PIN",
         "hu":"Hibás PIN",
         "nl":"Verkeerde pincode",
         "fr":"Mauvais PIN",
         "es":"PIN incorrecto"
      },
      "There is no game with this PIN":{
         "en":"There is no game with this PIN",
         "de":"Es gibt ken Spiel zu dieser PIN",
         "hu":"Nem találtunk játékot ezzel a PIN-el",
         "nl":"Er is geen spel met deze pincode",
         "fr":"Il n'y a pas de jeu lié à ce PIN",
         "es":"No hay ningún juego con este PIN"
      },
      "Cannot access location":{
         "en":"Cannot access location",
         "de":"Kann Standort nicht abrufen",
         "hu":"Lokáció letiltva",
         "nl":"Geen toegang tot locatie",
         "fr":"Impossible d'accéder à la localisation",
         "es":"No se puede acceder a la ubicación"
      },
      "You need to grant access to the browser to start the game.":{
         "en":"You need to grant access to the browser to start the game.",
         "de":"Sie müssen den Zugriff auf den Browser gewähren, um das Spiel zu starten.",
         "hu":"A lokáció engedélyezése szükséges a játékhoz.",
         "nl":"Je moet toegang verlenen tot de browser om het spel te starten.",
         "fr":"Vous devez autoriser l'accès au navigateur pour démarrer le jeu.",
         "es":"Necesitas otorgar acceso al navegador para iniciar el juego."
      },
      "You are standing outside the battle circle. You've lost ":{
         "en":"You are standing outside the battle circle. You've lost ",
         "de":"Außerhalb des Kreises! Strafscore: ",
         "hu":"A harci körön kívül állsz. Vesztettél: ",
         "nl":"Je staat buiten de spelcirkel. Je verloor",
         "fr":"Vous êtes en dehors du cercle. Vous avez perdu",
         "es":"Estás fuera del círculo de batalla. Has perdido "
      },
      " points!":{
         "en":" points!",
         "de":" Punkte",
         "hu":" pont.",
         "nl":" punten!",
         "fr":"points !",
         "es":" puntos!"
      },
      "Well, there are no markers nearby.":{
         "en":"Well, there are no markers nearby.",
         "de":"Keine Wegpunkte in der Nähe.",
         "hu":"Nincs kérdés a közeledben",
         "nl":"Nou, er zijn geen check-points in de buurt.",
         "fr":"Pas de marqueurs dans les environs.",
         "es":"Bueno, no hay marcadores cerca."
      },
      "Correct answer":{
         "en":"Correct answer",
         "de":"Richtige Antwort",
         "hu":"Helyes válasz",
         "nl":"Goed antwoord",
         "fr":"Bonne réponse ",
         "es":"Respuesta correcta"
      },
      "Correct answer! You have earned ":{
         "en":"Correct answer! You have earned ",
         "de":"Richtige Antwort! Du erhältst ",
         "hu":"Helyes válasz! Jutalmad: ",
         "nl":"Goed antwoord! Je hebt verdiend: ",
         "fr":"Bonne réponse! Vous avez obtenu",
         "es":"¡Respuesta correcta! Has ganado "
      },
      "You have earned ":{
         "en":"You have earned ",
         "de":"Du erhältst ",
         "hu":"Jutalmad: ",
         "nl":"Je hebt verdiend: ",
         "fr":"Vous avez obtenu",
         "es":"Has ganado "
      },
      "The correct answer would be: ":{
         "en":"The correct answer would be: ",
         "de":"Die richtige Antwort wäre: ",
         "hu":"A helyes válasz: ",
         "nl":"Het juiste antwoord was: ",
         "fr":"La bonne réponse serait : ",
         "es":"La respuesta correcta sería: "
      },
      "The time is up":{
         "en":"The time is up",
         "de":"Die Zeit ist abgelaufen.",
         "hu":"Lejárt az idő",
         "nl":"De tijd is op",
         "fr":"Le temps est terminé.",
         "es":"Se acabó el tiempo"
      },
      "A new item has been added to your backpack!":{
         "en":"A new item has been added to your backpack!",
         "de":"Ein neues Objekt wurde in den Rucksack gelegt.",
         "hu":"Új elem került a hátizsákodba",
         "nl":"Er is een nieuw item aan je rugzak toegevoegd!",
         "fr":"Un nouvel objet a été placé dans votre sac à dos !",
         "es":"¡Se ha añadido un nuevo artículo a tu mochila!"
      },
      "Incorrect answer":{
         "en":"Incorrect answer",
         "de":"Falsche Antwort",
         "hu":"Helytelen válasz",
         "nl":"Fout antwoord",
         "fr":"Mauvaise réponse",
         "es":"Respuesta incorrecta"
      },
      "Try again":{
         "en":"Try again",
         "de":"Nichmals versuchen",
         "hu":"Próbáld újra",
         "nl":"Probeer het opnieuw",
         "fr":"Réessayez",
         "es":"Inténtalo de nuevo"
      },
      "Start game":{
         "en":"Start game",
         "de":"Spiel starten",
         "hu":"Játék indítása",
         "nl":"Spel starten",
         "fr":"Commencer le jeu",
         "es":"Iniciar juego"
      },
      "Getting location data takes more time than usual. Please wait for the map to initialize":{
         "en":"Getting location data takes more time than usual. Please wait for the map to initialize",
         "de":"Den Standort abzurufen dauert länger, als üblich. Bitte warten, bis Karte gestartet wird.",
         "hu":"A térkép betöltése a szokásosnál több időt vesz igénybe. Kérjük várj.",
         "nl":"Locatiebepaling duurt langer dan voorzien. Wacht tot de kaart is geïnitialiseerd.",
         "fr":"Le téléchargement des données de localisation prend du temps. Merci de patienter.",
         "es":"Cargar los datos de ubicación lleva más tiempo de lo habitual. Por favor, espera a que se inicie el mapa."
      },
      "Location found, you can join to the game.":{
         "en":"Location found, you can join to the game.",
         "de":"Standort gefunden. Spiel beitreten.",
         "hu":"Aktuális pozíció betöltve.",
         "nl":"Locatie gevonden, je kan het spel opstarten",
         "fr":"Emplacement trouvé, vous pouvez commencer le jeu.",
         "es":"Ubicación encontrada, puedes unirte al juego."
      },
      "Available interactive games":{
         "en":"Available interactive games",
         "de":"Verfügbare interaktive Spiele",
         "hu":"Elérhető játékok",
         "nl":"Beschikbare spelconcepten",
         "fr":"Jeux interactifs disponibles",
         "es":"Juegos interactivos disponibles"
      },
      "Available games":{
         "en":"Available games",
         "de":"Verfügbare Spiele",
         "hu":"Elérhető játékok",
         "nl":"Beschikbare spelconcepten",
         "fr":"Jeux disponibles",
         "es":"Juegos disponibles"
      },
      "Switch language":{
         "en":"Change language",
         "de":"Sprache ändern",
         "hu":"Nyelv váltása",
         "nl":"Taal wijzigen",
         "fr":"Changer la langue",
         "es":"Cambiar idioma"
      },
      "Now we will redirect you to the payment page.":{
         "en":"Now we will redirect you to the payment page.",
         "de":"Die Weiterleitung zu Bezahlseite erfolgt nun.",
         "hu":"A tovább gomb lenyomásával továbbirányítunk a biztonságos Stripe fizetési oldalra. A bankkártyás fizetést követően a játékhoz szükséges információkat email formájában fogod megkapni.",
         "nl":"We zullen je omleiden naar de betaalpagina",
         "fr":"Vous allez être redirigé vers la page de paiement.",
         "es":"Ahora te redirigiremos a la página de pago."
      },
      "Checkout":{
         "en":"Checkout",
         "de":"Zur Kasse",
         "hu":"Fizetés",
         "nl":"Betalen",
         "fr":"Passer à la caisse",
         "es":"Pagar"
      },
      "Confirm":{
         "en":"Confirm",
         "de":"Bestätigung",
         "hu":"Rendben",
         "nl":"Bevestigen",
         "fr":"Confirmer",
         "es":"Confirmar"
      },
      "Not supported browser":{
         "en":"Not supported browser",
         "de":"Nicht unterstützter Browser",
         "hu":"Nem támogatott böngésző",
         "nl":"Niet ondersteunde browser ",
         "fr":"Navigateur non compatible",
         "es":"Navegador no compatible"
      },
      "The game only supports Chrome or Safari mobile browsers. ":{
         "en":"The game only supports Chrome or Safari mobile browsers. ",
         "de":"Das Spiel unterstützt nur CHROME und SAFARI Mobile Browser.",
         "hu":"A játék kizárólag Chrome vagy Safari böngészőkben játszható. ",
         "nl":"Het spel ondersteunt alleen mobiele Chrome- of Safari-browsers. ",
         "fr":"Le jeu est compatible uniquement avec Chrome ou Safari.",
         "es":"El juego solo es compatible con los navegadores móviles Chrome o Safari. "
      },
      "Double your points at the next question":{
         "en":"Double your points at the next question",
         "de":"Verdoppeln Sie Ihre Punkte bei der nächsten Frage",
         "hu":"A következő kérdés dupla vagy semmi ",
         "nl":"Verdubbel je punten op de volgende vraag",
         "fr":"Doublez vos points à la prochaine question",
         "es":"Duplica tus puntos en la siguiente pregunta"
      },
      "You can freeze all players for 30 seconds":{
         "en":"You can freeze all players for 30 seconds",
         "de":"Sie können alle Spieler für 30 Sekunden einfrieren",
         "hu":"Lefagyaszthatod az összes játékost 30 másodpercre ",
         "nl":"Je kunt alle andere teams 30 seconden bevriezen",
         "fr":"Vous pouvez geler les autres joueurs pendant 30 secondes",
         "es":"Puedes congelar a todos los jugadores durante 30 segundos"
      },
      "Be aware":{
         "en":"Be aware",
         "de":"Sei vorsichtig",
         "hu":"Figyelem",
         "nl":"Pas op",
         "fr":"Attention",
         "es":"Ten cuidado"
      },
      "Please note that the game only supports Chrome or Safari browsers. Do you want to proceed?":{
         "en":"Please note that the game only supports Chrome and Safari browsers. Do you want to proceed?",
         "de":"Bitte beachten Sie, dass das Spiel nur die Browser Chrome und Safari unterstützt. Willst du fortfahren?",
         "hu":"Felhívjuk a figyelmedet, hogy a játék csak a Chrome és a Safari böngészőket támogatja. Biztosan akarod folytatni?",
         "nl":"Houd er rekening mee dat het spel alleen Chrome- en Safari-browsers ondersteunt. Wil je doorgaan?",
         "fr":"Veuillez noter que le jeu est compatible uniquement avec Chrome ou Safari. Vous voulez continuer ? ",
         "es":"Tenga en cuenta que el juego solo es compatible con los navegadores Chrome y Safari. ¿Quieres continuar?"
      },
      "Yes":{
         "en":"Yes",
         "de":"Jawohl",
         "hu":"Igen",
         "nl":"Ja",
         "fr":"Oui",
         "es":"Sí"
      },
      "Felfedezős kalandjáték a mobilodon itt és most.":{
         "en":"Treasure hunt on your mobile! Here and now!",
         "de":"Schatzsuche auf Ihrem Handy! Hier und Jetzt!",
         "hu":"Felfedezős kalandjáték a mobilodon itt és most.",
         "nl":"Schattenjacht op je mobiel toestel! Hier en nu!",
         "fr":"Une chasse au trésors sur votre smartphone ? C'est par ici !",
         "es":"¡Búsqueda del tesoro en tu móvil! ¡Aquí y ahora!"
      },
      "Játékok":{
         "en":"Games",
         "de":"Spiele",
         "hu":"Játékok",
         "nl":"Spelconcepten",
         "fr":"Jeux",
         "es":"Juegos"
      },
      "A legteljesebb játékélményhez Chrome és Safari böngészők használata ajánlott.":{
         "en":"The game only supports Chrome or Safari mobile browsers. ",
         "de":"Das Spiel unterstützt nur CHROME und SAFARI Mobile Browser.",
         "hu":"A legteljesebb játékélményhez Chrome és Safari böngészők használata ajánlott. ",
         "nl":"Het spel ondersteunt alleen mobiele Chrome- of Safari-browsers. ",
         "fr":"Le jeu est compatible uniquement avec Chrome ou Safari.",
         "es":"El juego solo es compatible con los navegadores móviles Chrome o Safari."
      },
      "Mire számítsak?":{
         "en":"What do I expect?",
         "de":"Was erwarte ich?",
         "hu":"Mire számítsak?",
         "nl":"Wat te verwachten?",
         "fr":"Qu'est-ce qui m'attend ?"
         ,"es":"¿Qué puedo esperar?"
      },
      "A játék":{
         "en":"The game",
         "de":"Das Spiel",
         "hu":"A játék",
         "nl":"Het spel",
         "fr":"Le jeu",
         "es":"El juego"
      },
      "A játék során számos izgalmas kérdés és feladat által fedezed fel a helyszínt, és megismered titkait. A játék meglepetéseket is tartogat...":{
         "en":"During the game, you will explore the scene and learn its secrets through a number of exciting questions and tasks. The game also has surprises ...",
         "de":"Während des Spiels erkunden Sie die Szene und lernen ihre Geheimnisse durch eine Reihe spannender Fragen und Aufgaben kennen. Das Spiel hat auch Überraschungen ...",
         "hu":"A játék során számos izgalmas kérdés és feladat által fedezed fel a helyszínt, és ismered meg titkait. A játék meglepetéseket is tartogat...",
         "nl":"Tijdens het spel verken je de scène en leer je de geheimen ervan door middel van een aantal spannende vragen en taken. Het spel heeft ook verrassingen ...",
         "fr":"Au cours du jeu, vous explorerez le terrain et découvrirez ses secrets à travers des questions et des énigmes passionnantes. Plein de surprises vous attendent !",
         "es":"Durante el juego, explorarás la escena y aprenderás sus secretos a través de una serie de preguntas y tareas emocionantes. El juego también tiene sorpresas ..."
      },
      "Szerezz minél több pontot! Ehhez a térképen megjelölt helyszínekre kell eljutnod, ill. a kihelyezett QR kódokat beolvasnod.":{
         "en":"Get as many points as possible! To do this, you need to get to the locations marked on the map, or you can scan the posted QR codes.",
         "de":"Holen Sie sich so viele Punkte wie möglich! Dazu müssen Sie zu den auf der Karte markierten Orten gelangen oder Sie können die geposteten QR-Codes scannen.",
         "hu":"Szerezz minél több pontot! Ehhez a térképen megjelölt helyszínekre kell eljutnod, ill. a kihelyezett QR kódokat beolvasnod.",
         "nl":"Scoor zoveel mogelijk punten! Om dit te doen, moet je naar de locaties die op de kaart zijn gemarkeerd, of je kunt de QR-codes scannen.",
         "fr":"Obtenez le plus de points possible ! Pour ça, vous devez vous rendre aux endroits indiqués sur la carte, ou vous pouvez scanner les codes QR affichés.",
         "es":"¡Consigue tantos puntos como sea posible! Para ello, debes llegar a las ubicaciones marcadas en el mapa, o puedes escanear los códigos QR publicados."
      },
      "Válaszd ki a játékot és kattints a \"Játék indítása\" gombra, amelyet követően a játék azonnal indul. Az első két feladvány ingyenes, amelyet után online bankkártyás fizetést követően folytathatod azt. Kalandra fel!":{
         "en":"Select the game and click on the \"Start Game\" button, after which the game will start immediately. The first two puzzles are free, and after that, you can continue by making an online payment with your credit card. Adventure awaits!",
         "de":"Wähle das Spiel aus und klicke auf die Schaltfläche \"Spiel starten\", danach beginnt das Spiel sofort. Die ersten beiden Rätsel sind kostenlos und danach kannst du sie durch eine Online-Zahlung mit deiner Kreditkarte fortsetzen. Abenteuer wartet!",
         "hu":"Válaszd ki a játékot és kattints a \"Játék indítása\" gombra, ezt követően a játék azonnal indul. Az első két feladvány ingyenes. Ezután online bankkártyás fizetéssel egyenlítsd ki a játék díját, hogy folytathasd. Kalandra fel!",
         "nl":"Kies het spel en klik op de knop \"Start spel\", waarna het spel direct begint. De eerste twee puzzels zijn gratis, en daarna kun je verdergaan door een online betaling met je creditcard te doen. Avontuur wacht!",
         "fr":"Sélectionnez le jeu et cliquez sur le bouton \"Commencer le jeu\", après quoi le jeu commencera immédiatement. Les deux premières énigmes sont gratuites, et après cela, vous pouvez continuer en effectuant un paiement en ligne avec votre carte de crédit. L'aventure vous attend !",
      },
      "Pontok":{
         "en":"Points",
         "de":"Punkte",
         "hu":"Pontok",
         "nl":"Punten",
         "fr":"Points",
         "es":"Puntos"
      },
      "A játék indítása":{
         "en":"Start the game",
         "de":"Starte das Spiel",
         "hu":"A játék indítása",
         "nl":"Start het spel",
         "fr":"Commencer le jeu",
         "es":"Iniciar el juego"
      },
      "Tovább a biztonságos fizetésre":{
         "en":"Secure payment",
         "de":"Sichern Sie weiterhin die Zahlung",
         "hu":"Tovább a biztonságos fizetésre",
         "nl":"Beveiligde betaling",
         "fr":"Paiement sécurisé",
         "es":"Pago seguro"
      },
      "Lépj kapcsolatba velünk:":{
         "en":"Contact us:",
         "de":"Kontaktiere uns:",
         "hu":"Lépj kapcsolatba velünk:",
         "nl":"Neem contact met ons op:",
         "fr":"Contact : ",
         "es":"Contáctanos:"
      },
      "Checking location data":{
         "en":"Checking location data",
         "de":"Überprüfung der Standortdaten",
         "hu":"Lokáció adatok frissítése",
         "nl":"Locatiegegevens controleren",
         "fr":"Vérification des données de localisation",
         "es":"Comprobando datos de ubicación"
      },
      "Loading game":{
         "en":"Loading game",
         "de":"Spiel lädt",
         "hu":"Betöltés",
         "nl":"Spel laden",
         "fr":"Chargement du jeu",
         "es":"Cargando juego"
      },
      "Congrats! You unlocked the last marker!":{
         "en":"Congrats! You unlocked the last marker!",
         "de":"Herzlichen Glückwunsch! Du hast die letzte Markierung freigeschaltet!",
         "hu":"Gratulálunk! Aktiváltad az utolsó pontot!",
         "nl":"Gefeliciteerd! Je hebt het laatste check-point ontgrendeld!",
         "fr":"Félicitations, vous avez débloqué la dernIère énigme !",
         "es":"¡Felicidades! ¡Has desbloqueado el último marcador!"
      },
      "Splashed egg":{
         "en":"Splashed egg",
         "de":"Rohes Ei",
         "hu":"Fröccsenő tojás",
         "nl":"Opengespat ei",
         "fr":"oeuf éclaté",
         "es":"Huevo estrellado"
      },
      "blank_map":{
         "en":"Splashed egg",
         "de":"Rohes Ei",
         "hu":"Fröccsenő tojás",
         "nl":"Opengespat ei",
         "fr":"oeuf éclaté",
         "es":"Huevo estrellado"
      },
      "A splashed egg is displayed to players, obscuring the map for 30 seconds.":{
         "en":"A splashed egg is displayed to players, obscuring the map for 30 seconds.",
         "de":"Ein bespritztes Ei wird den Spielern angezeigt und verdeckt die Karte für 30 Sekunden.",
         "hu":"Egy fröccsenő tojás jelenik meg a játékosok térképén, amely akadályozza a látásukat 30 másodpercig.",
         "nl":"De andere teams krijgen een opengespat ei te zien, waardoor hun kaart gedurende 30 seconden wordt verduisterd.",
         "fr":"Un oeuf éclaté apparaît aux joueurs, masquant la carte pendant 30 secondes.",
         "es":"Se muestra un huevo estrellado en la pantalla de los demás jugadores, tapando el mapa durante 30 segundos."
      },
      "Splashed egg perk is active for 30 seconds.":{
         "en":"Splashed egg perk is active for 30 seconds.",
         "de":"Der Perk „Bespritztes Ei“ ist 30 Sekunden lang aktiv.",
         "hu":"A fröccsenő tojás 30 másodpercig aktív.",
         "nl":"Opengespat ei is 30 seconden actief.",
         "fr":"Effet oeuf éclaté activé pendant 30 secondes.",
         "es":"El beneficio de huevo estrellado está activo durante 30 segundos."
      },
      "Flinkit is a new real world adventure game packed with codes to be cracked, clues to be uncovered, and puzzles to be solved in and outside. Fast, fun and easy to get going.":{
         "en":"The game is a new real world adventure game packed with codes to be cracked, clues to be uncovered, and puzzles to be solved in and outside. Fast, fun and easy to get going.",
         "de":"RallyePlus Outdoor ist ein neuartiges Outdoorspiel, voller Abenteuer und kniffliger Aufgaben. Sie erhalten Punkte für jede gelöste Aufgabe. Das Team mit den meisten Punkten gewinnt.",
         "hu":"A Flinkit egy a valós világban játszódó, mégis online kalandjáték, tele izgalmas fejtörőkkel, ahol nyomokat kell feltárni, és rejtvényeket kell megoldani. Gyors, szórakoztató és élménydús.",
         "nl":"Ludiris Outdoor! is een innovatief spel waarbij je zo secuur mogelijk een aantal vragen dient op te lossen op bepaalde locaties. Speel dit spel tegen elkaar in de stad. Snel, leuk en makkelijk te spelen.",
         "fr":"Flinkit Rallye Outdoor est un nouveau jeu d'aventures à l'extérieur où vous devez déchiffrer des codes, découvrir des indices et résoudre des énigmes. Chaque énigme résolue rapporte des points. L'équipe avec le maximum de points remporte la victoire. ",
         "es":"¡Bienvenida! Este juego es una nueva aventura del mundo real, llena de códigos por descifrar, pistas por descubrir y acertijos por resolver, tanto dentro como fuera. Es rápido, divertido y muy fácil de empezar."
      },
      "Map tap":{
         "en":"Teleport",
         "de":"Teleport",
         "hu":"Térkép érintés",
         "nl":"Teleportatie",
         "fr":"Toucher la carte",
         "es":"Toca el mapa"
      },
      "teleport":{
         "en":"Teleport",
         "de":"Teleport",
         "hu":"Térkép érintés",
         "nl":"Teleportatie",
         "fr":"Toucher la carte",
         "es":"Toca el mapa"
      },
      "Simulate your position by tapping on the map.":{
         "en":"Simulate your position by tapping on the map.",
         "de":"Simulieren Sie Ihre Position, indem Sie auf die Karte tippen.",
         "hu":"A térképen a megérintett pontra tudsz ugrani, így egy távoli pontot könnyen begyűjthetsz. A funkció 30 mp-ig él.",
         "nl":"Simuleer je positie door op de kaart te tikken.",
         "fr":"Simulez votre position en tapant sur la carte.",
         "es":"Simula tu posición tocando el mapa."
      },
      "Tap on the map to simulate your position and reach remote points for up to 30 seconds. Please wait 5 seconds after activating this perk before starting to tap.":{
         "en":"Tap on the map to simulate your position and reach remote points for up to 30 seconds. Please wait 5 seconds after activating this perk before starting to tap.",
         "de":"Sie können Ihre Position simulieren, indem Sie auf die Karte tippen, was es Ihnen ermöglicht, entfernte Punkte für bis zu 30 Sekunden zu erreichen. Bitte warten Sie 5 Sekunden, nachdem Sie diesen Perk aktiviert haben, und beginnen Sie dann, auf die Karte zu tippen.",
         "hu":"A térképen a megérintett pontra tudsz ugrani, így egy távoli pontot könnyen begyűjthetsz. A funkció 30 mp-ig él. Kérjük várj 5 másodpercet miután aktiváltad ezt a funkciót, majd kezdj el a térképen kattintani.",
         "nl":"Hiermee kun je je positie simuleren door ergens op de kaart te tikken, waardoor je gedurende 30 seconden virtueel tot bij ver afgelegen punten kunt komen. Wacht 5 seconden nadat je deze functie hebt geactiveerd, en begin dan op de kaart te tikken.",
         "fr":"Vous pouvez simuler votre position en tapant sur la carte, ce qui vous permet d'atteindre des endroits éloignés pendant 30 secondes. Veuillez attendre 5 secondes après avoir activé cet effet, puis commencez à taper sur la carte.",
         "es":"Toca en el mapa para simular tu posición y llegar a puntos remotos durante hasta 30 segundos. Espera 5 segundos después de activar este beneficio antes de empezar a tocar."
      },
      "Take a photo":{
         "en":"Take a photo",
         "de":"Mach ein Foto",
         "hu":"Fotó készítése",
         "nl":"Maak een foto",
         "fr":"Prendre une photo",
         "es":"Tomar una foto"
      },
      "No image selected":{
         "en":"No image selected",
         "de":"Kein Bild ausgewählt",
         "hu":"Nincs kép kiválasztva",
         "nl":"Geen afbeelding geselecteerd",
         "fr":"Aucune image sélectionnée",
         "es":"Ninguna imagen seleccionada"
      },
      "Upload image":{
         "en":"Upload image",
         "de":"Bild hochladen",
         "hu":"Kép feltöltése",
         "nl":"Afbeelding uploaden",
         "fr":"Télécharger l'image",
         "es":"Subir imagen"
      },
      "You've arrived to the last question":{
         "en":"You've arrived to the last question",
         "de":"Sie sind bei der letzten Frage angelangt",
         "hu":"Megérkeztél az utolsó kérdéshez!",
         "nl":"Je bent aangekomen bij de laatste vraag",
         "fr":"Vous êtes arrivé à la dernière question !",
         "es":"¡Has llegado a la última pregunta!"
      },
      "You can unlock questions by approaching them. The points are triggered when you stand in a 10 meters radius.":{
         "en":"You can unlock questions by approaching them. The points are triggered when you stand in a 10 meters radius.",
         "de":"Sie können Fragen freischalten, indem Sie sich ihnen nähern. Die Punkte werden ausgelöst, wenn Sie in einem Umkreis von 10 Metern stehen.",
         "hu":"A pontok akkor aktiválódnak, ha 10 méteres körzetben állsz.",
         "nl":"Je kunt vragen ontgrendelen door check-points te benaderen. De punten worden geactiveerd wanneer je je binnen een straal van 10 meter bevindt.",
         "fr":"Vous débloquez des questions en vous en rapprochant. Les points sont activés lorsque vous vous trouvez dans un rayon de 10 mètres.",
         "es":"Puedes desbloquear preguntas acercándote a ellas. Los puntos se activan cuando te encuentras en un radio de 10 metros."
      },
      "Please contact your program facilitator":{
         "en":"Please contact your program facilitator",
         "de":"Bitte wenden Sie sich an Ihren Spieladministrator",
         "hu":"Vedd fel a kapcsolatot a játék szervezőjével",
         "nl":"Neem contact op met je spelbeheerder",
         "fr":"Veuillez contacter votre responsable de jeu",
         "es":"Por favor contacta a tu facilitador del juego"
      },
      "Refresh":{
         "en":"Refresh",
         "de":"Aktualisierung",
         "hu":"Frissítés",
         "nl":"Vernieuwen",
         "fr":"Rafraîchir",
         "es":"Actualizar"
      },
      "In order to continue the game we redirect you to the checkout page. After the checkout you will be redirected to the game.":{
         "en":"To continue playing, the purchase of the game is necessary. We will redirect you to the payment interface for this purpose. After a successful payment, we will redirect you back to the game.",
         "de":"In order to continue the game we redirect you to the checkout page. After the checkout you will be redirected to the game.",
         "hu":"A játék folytatásához szükséges annak megvásárlása. Ehhez átirányítunk a fizetési felületre. A sikeres fizetés után pedig visszairányítunk a játékba.",
         "nl":"Om het spel te beëindigen, brengen we je naar de betaalpagina. Na betaling word je terug naar het spel gestuurd.",
         "fr":"Afin de continuer le jeu, l’achat du jeu est nécessaire. Nous vous redirigerons vers l’interface de paiement à cette fin. Après un paiement réussi, nous vous redirigerons vers le jeu.",
         "es":"Para continuar jugando, es necesaria la compra del juego. Te redirigiremos a la interfaz de pago para este propósito. Después de un pago exitoso, te redirigiremos de vuelta al juego."
      },
      "Proceed to checkout":{
         "en":"Proceed to checkout",
         "de":"Proceed to checkout",
         "hu":"Tovább a fizetésre",
         "nl":"Ga naar betaling",
         "fr":"Passer à la caisse",
         "es":"Proceder al pago"
      },
      "Játék indítása":{
         "en":"Start game",
         "de":"Spiel starten",
         "hu":"Játék indítása",
         "nl":"Start spel",
         "fr":"Démarrer le jeu",
         "es":"Iniciar juego"
      },
      "Uh oh":{
         "en":"Uh oh!",
         "de":"Uh oh!",
         "hu":"Hoppá!",
         "nl":"Uh oh!",
         "fr":"Oops!",
         "es":"¡Ups!"
      },
      "Your email address":{
         "en":"Your email address",
         "de":"Your email address",
         "hu":"Email címed",
         "nl":"Jouw mailadres",
         "fr":"Votre adresse e-mail",
         "es":"Tu dirección de correo electrónico"
      },
      "Enter your email address":{
         "en":"Enter your email address!",
         "de":"Enter your email address",
         "hu":"Kérjük add meg az email címedet",
         "nl":"Geef je mailadres in",
         "fr":"Entrez votre adresse e-mail",
         "es":"¡Ingresa tu dirección de correo electrónico!"
      },
      "OK":{
         "en":"OK",
         "de":"OK",
         "hu":"OK",
         "nl":"OK",
         "fr":"OK",
         "es":"OK"
      },
      "Player name/team name":{
         "en":"Player name/team name",
         "de":"Spielername/Teamname",
         "hu":"Játékosnév/csapatnév",
         "nl":"Spelersnaam/teamnaam",
         "fr":"Nom du joueur/nom de l'équipe",
         "es":"Nombre del jugador/nombre del equipo"
      },
      "You can unlock questions by finding QR codes in the museum (marked on the map) and scanning them with the 'Scan QR Code' button.":{
         "en":"You can unlock questions by finding QR codes in the event space (marked on the map) and scanning them with the 'Scan QR Code' button.",
         "de":"Sie können Fragen freischalten, indem Sie im Gebäude QR-Codes (auf der Karte markiert) finden und mit der Schaltfläche „QR-Code scannen“ scannen.",
         "hu":"Keresd meg a QR kódokat és szkenneld be őket.",
         "nl":"Je kunt vragen ontgrendelen door QR-codes te vinden (aangegeven op de kaart) en deze te scannen met de knop 'Scan QR Code'.",
         "fr":"Vous pouvez déverrouiller les questions en trouvant des codes QR dans le musée (marqués sur la carte) et en les scannant avec le bouton Scanner le code QR.",
         "es":"Puedes desbloquear preguntas encontrando códigos QR en el museo (marcados en el mapa) y escaneándolos con el botón 'Escanear código QR'."
      },
      "Congrats! The game has ended!":{
         "en":"Congrats! <br> The game has ended!",
         "de":"Glückwunsch! <br> Das Spiel ist beendet!",
         "hu":"Gratulálunk! <br> A játék véget ért!",
         "nl":"Gefeliciteerd! <br> Het spel is afgelopen!",
         "fr":"Bravo! <br> Le jeu est terminé !",
         "es":"¡Felicidades! <br> ¡El juego ha terminado!"
      },
      "Reconnect":{
         "en":"Reconnect",
         "de":"Reconnect",
         "hu":"Újracsatlakozás",
         "nl":"Opnieuw verbinden",
         "fr":"Reconnecter",
         "es":"Reconectar"
      },
      Send: {
         en: 'Send',
         de: 'Send',
         hu: 'Küldés',
         nl: 'Send',
         fr: 'Envoyer',
         es: 'Enviar',
         },
      "Send message to Game host": {
         en: 'Send message to Game host',
         de: 'Nachricht an den Spielleiter senden',
         hu: 'Üzenet küldése a játékvezetőnek',
         nl: 'Bericht sturen naar de spelleider',
         fr: 'Envoyer un message à l`hôte du jeu',
         es: 'Enviar mensaje al anfitrión del juego',
         },
     "You can send message to the game master": {
         en: 'You can send message to the game master',
         de: 'You can send message to the game master',
         hu: 'Üzenetet küldhetsz a játékmesternek',
         nl: 'Je kunt een bericht sturen naar de spelmeester',
         fr: 'Vous pouvez envoyer un message au maître du jeu',
         es: 'Puedes enviar un mensaje al maestro del juego',
         },
         "Text Input": {
          en: 'Text Input',
          de: 'Text Input',
          hu: 'Szöveg bevitel',
          nl: 'Tekstinvoer',
          fr: 'Text Input',
          es: 'Entrada de texto',
          },
          "text_input": {
            en: 'Text Input',
            de: 'Texteingabe',
            hu: 'Szöveg bevitel',
            nl: 'Tekstinvoer',
            fr: 'Text Input',
            es: 'Entrada de texto',
            },
            "Somebody froze all the players for 30 seconds.":{
               "en":"Somebody froze all the players for 30 seconds.",
               "de":"Jemand hat alle Spieler für 30 Sekunden eingefroren.",
               "hu":"Valaki 30 másodpercre befagyaszotta az összes játékost.",
               "nl":"Iemand heeft alle teams 30 seconden bevroren.",
               "fr":"Quelqu'un a gelé tous les joueurs pendant 30 secondes.",
               "es":"Alguien congeló a todos los jugadores durante 30 segundos."
            },
            "Text snippet sent": {
               "en":"Text snippet sent",
               "de":"Textausschnitt gesendet",
               "hu":"Szöveg elküldve",
               "nl":"Tekstfragment verzonden",
               "fr":"Extrait de texte envoyé",
               "es":"Fragmento de texto enviado"
            },
            "The goal of the game is collect as many points as you can while solve riddles on the map.": {
               "en":"The goal of the game is collect as many points as you can while solving riddles on the map.",
               "de":"Das Ziel des Spiels ist es, so viele Punkte wie möglich zu sammeln, während Sie Rätsel auf der Karte lösen.",
               "hu":"A játék célja, hogy minél több pontot gyűjts, miközben rejtélyeket oldasz meg.",
               "nl":"Het doel van het spel is om zoveel mogelijk punten te verzamelen terwijl je raadsels op de kaart oplost.",
               "fr":"Le but du jeu est de collecter autant de points que possible tout en résolvant des énigmes sur la carte.",
               "es":"El objetivo del juego es recolectar tantos puntos como puedas mientras resuelves acertijos en el mapa."
            },
            "This question will earn you": {
               "en":"This question will earn you",
               "de":"Diese Frage bringt dir",
               "hu":"Ez a kérdés",
               "nl":"Deze vraag levert je",
               "fr":"Cette question vous rapportera",
               "es":"Esta pregunta te dará"
            
            }, 
            " points if your answer is correct.": {
               "en":" points if your answer is correct.",
               "de":" Punkte, wenn deine Antwort richtig ist.",
               "hu":" pontot ér, ha a válaszod helyes.",
               "nl":" punten oplevert als je antwoord juist is.",
               "fr":" points si votre réponse est correcte.",
               "es":" puntos si tu respuesta es correcta."
            
            },
            "Photo Validated!": {
               "en":"Photo accepted!",
               "de":"Foto validiert!",
               "hu":"Remek fotó, köszönjük!",
               "nl":"Foto gevalideerd!",
               "fr":"Photo validée!",
               "es":"¡Foto validada!"
            },
            "Your photo has been validated and you earned ":{
               "en":"Your photo has been validated and you earned ",
               "de":"Ihr Foto wurde validiert und Sie haben verdient ",
               "hu":"A jutalmad ",
               "nl":"Je foto is gevalideerd en je hebt verdiend ",
               "fr":"Votre photo a été validée et vous avez gagné ",
               "es":"Tu foto ha sido validada y has ganado "
            
            },
            " points.": {
               "en":" points.",
               "de":" Punkte.",
               "hu":" pont.",
               "nl":" punten.",
               "fr":" points.",
               "es":" puntos."
            },
           "By Distance": {
               "en":"By Distance",
               "de":"Nach Entfernung",
               "hu":"Távolság szerint",
               "nl":"Op afstand",
               "fr":"Par distance",
               "es":"Por distancia"
           },
           "Your opinion helps us make the game even better for you!": {
               "en":"Your opinion helps us make the game even better for you!",
               "de":"Ihre Meinung hilft uns, das Spiel noch besser für Sie zu machen!",
               "hu":"A véleményed segít nekünk, hogy a játék még jobb legyen számodra!",
               "nl":"Uw mening helpt ons het spel nog beter voor u te maken!",
               "fr":"Votre avis nous aide à rendre le jeu encore meilleur pour vous!",
               "es":"¡Tu opinión nos ayuda a hacer el juego aún mejor para ti!"
           },
           "Skip": {
               "en":"Skip",
               "de":"Überspringen",
               "hu":"Kihagy",
               "nl":"Overslaan",
               "fr":"Passer",
               "es":"Omitir"
           },
           "Share your thoughts about the game...": {
               "en":"Share your thoughts about the game...",
               "de":"Teilen Sie Ihre Gedanken zum Spiel...",
               "hu":"Oszd meg a véleményed a játékról...",
               "nl":"Deel je gedachten over het spel...",
               "fr":"Partagez vos pensées sur le jeu...",
               "es":"Comparte tus pensamientos sobre el juego..."
           },
           "Message for the image": {
               "en":"Message for the image",
               "de":"Nachricht für das Bild",
               "hu":"Üzenet a képhez",
               "nl":"Bericht voor de afbeelding",
               "fr":"Message pour l'image",
               "es":"Mensaje para la imagen"
           },
           "Game master's notes": {
               "en":"Game master's notes",
               "de":"Spielmeister-Notizen",
               "hu":"Játékmester jegyzetei",
               "nl":"Notities van de spelleider",
               "fr":"Notes du maître du jeu",
               "es":"Notas del maestro del juego"
           },
           "No image selected. You need to upload an image according to the task/question.": {
               "en":"No image selected. You need to upload an image according to the task/question.",
               "de":"Kein Bild ausgewählt. Sie müssen ein Bild gemäß der Aufgabe/Frage hochladen.",
               "hu":"Nincs kép kiválasztva. Kérjük tölts fel egy képet a kérdésnek megfelelően.",
               "nl":"Geen afbeelding geselecteerd. Je moet een afbeelding uploaden volgens de taak/vraag.",
               "fr":"Aucune image sélectionnée. Vous devez télécharger une image selon la tâche/question.",
               "es":"Ninguna imagen seleccionada. Necesitas subir una imagen según la tarea/pregunta."
           },
           "Select image": {
             "en": "Select image",
               "de": "Bild auswählen",
               "hu": "Fotó készítése",
               "nl": "Afbeelding selecteren",
                "fr": "Sélectionner une image",
                "es": "Seleccionar imagen"

           },
           "Task completed!": {
               "en":"Task completed!",
               "de":"Aufgabe abgeschlossen!",
               "hu":"Feladat kész!",
               "nl":"Taak voltooid!",
               "fr":"Tâche accomplie!",
               "es":"¡Tarea completada!"
           },
           "Congrats! You have completed the task! Points will be added to your account later by the game master!": {
               "en":"Congrats! You have completed the task! Points will be added to your account later by the game master!",
               "de":"Herzlichen Glückwunsch! Sie haben die Aufgabe abgeschlossen! Die Punkte werden später von der Spielleitung Ihrem Konto gutgeschrieben!",
               "hu":"Gratulálunk! Teljesítetted a feladatot! A pontokat később a játékmester írja jóvá!",
               "nl":"Gefeliciteerd! Je hebt de taak voltooid! De punten worden later door de spelleider aan je account toegevoegd!",
               "fr":"Félicitations ! Vous avez terminé la tâche ! Les points seront ajoutés à votre compte plus tard par le maître du jeu !",
               "es":"¡Felicidades! ¡Has completado la tarea! ¡Los puntos serán añadidos a tu cuenta más tarde por el maestro del juego!"
           },
           "Game cards": {
               "en":"Game cards",
               "de":"Spielkarten",
               "hu":"Játék kártyák",
               "nl":"Spel kaarten",
               "fr":"Cartes de jeu",
               "es":"Cartas de juego"
           },
           "New game card available!": {
               "en":"New game card available!",
               "de":"Neue Spielkarte verfügbar!",
               "hu":"Új játék kártya elérhető!",
               "nl":"Nieuwe spelkaart beschikbaar!",
               "fr":"Nouvelle carte de jeu disponible!",
               "es":"¡Nueva carta de juego disponible!"
           },
           "Oops": {
               "en":"Oops",
               "de":"Ups",
               "hu":"Hoppá",
               "nl":"Oeps",
               "fr":"Oups",
               "es":"Ups"
           },
           "Something went wrong or the link is broken": {
               "en":"Something went wrong or the link is broken",
               "de":"Etwas ist schief gelaufen oder der Link ist kaputt",
               "hu":"Valami hiba történt vagy a link törött",
               "nl":"Er is iets misgegaan of de link is gebroken",
               "fr":"Quelque chose s'est mal passé ou le lien est cassé",
               "es":"Algo salió mal o el enlace está roto"
           },
           "Player limit reached. However, if you want to rejoin a game, please make sure you use the exact same team name you used before.":  {
               "en":"Player limit reached. However, if you want to rejoin a game, please make sure you use the exact same team name you used before.",
               "de":"Spielerlimit erreicht. Wenn Sie jedoch wieder einem Spiel beitreten möchten, stellen Sie bitte sicher, dass Sie denselben Teamnamen verwenden, den Sie zuvor verwendet haben.",
               "hu":"Elérted a maximális létszámot. Ha újra szeretnél csatlakozni a játékhoz, kérlek használd ugyanazt a csapatnevet, mint korábban.",
               "nl":"Spelerlimiet bereikt. Als je echter opnieuw wilt deelnemen aan een spel, zorg er dan voor dat je dezelfde teamnaam gebruikt als eerder.",
               "fr":"Limite de joueurs atteinte. Cependant, si vous souhaitez rejoindre à nouveau un jeu, assurez-vous d'utiliser le même nom d'équipe que précédemment.",
               "es":"Límite de jugadores alcanzado. Sin embargo, si quieres volver a unirte a un juego, asegúrate de usar exactamente el mismo nombre de equipo que usaste antes."
            },
            "Photo title": {
               "en":"Photo title",
               "de":"Fototitel",
               "hu":"Fotó cím",
               "nl":"Fototitel",
               "fr":"Titre de la photo",
               "es":"Título de la foto"
            },
            "Tap for the next card": {
               "en":"Tap for the next card",
               "de":"Tippen Sie auf die nächste Karte",
               "hu":"Koppints a következő kártyához",
               "nl":"Tik voor de volgende kaart",
               "fr":"Tapez pour la carte suivante",
               "es":"Toca para la siguiente carta"
            },
            "Image upload failed. Maybe it is a problem with the file size. Please try again with selecting a file from your gallery or take a new photo using your front camera.": {
               "en": "Image upload failed. Maybe it is a problem with the file size. Please try again with selecting a file from your gallery or take a new photo using your front camera.",
               "de": "Bild-Upload fehlgeschlagen. Vielleicht liegt es am Dateigröße. Bitte versuchen Sie es erneut, indem Sie eine Datei aus Ihrer Galerie auswählen oder ein neues Foto mit Ihrer Frontkamera aufnehmen.",
               "hu": "A kép feltöltése nem sikerült. Talán a fájlmérettel van probléma. Kérjük, próbálja újra úgy, hogy kiválaszt egy fájlt a galériából, vagy készít egy új fényképet az elülső kamerával.",
               "nl": "Afbeelding uploaden mislukt. Misschien ligt het aan de bestandsgrootte. Probeer het opnieuw door een bestand uit je galerij te selecteren of maak een nieuwe foto met je frontcamera.",
               "fr": "Le téléchargement de l'image a échoué. Il se peut que le problème vienne de la taille du fichier. Veuillez réessayer en sélectionnant une image depuis votre galerie ou en prenant une nouvelle photo avec votre caméra frontale.",
               "es": "Falló la subida de imagen. Quizá sea un problema con el tamaño del archivo. Por favor inténtalo de nuevo seleccionando un archivo de tu galería o toma una nueva foto usando tu cámara frontal."
            }, 
            "questions answered": {
               "en":"questions answered",
               "de":"beantwortete Fragen",
               "hu":"megválaszolt kérdés",
               "nl":"beantwoorde vragen",
               "fr":"questions répondues",
               "es":"preguntas respondidas"
            },
            "remaining questions": {
               "en":"remaining questions",
               "de":"verbleibende Fragen",
               "hu":"hátralévő kérdés",
               "nl":"overgebleven vragen",
               "fr":"questions restantes",
               "es":"preguntas restantes"
            },
            "Photo Not Accepted": {
               "en":"Photo Not Accepted",
               "de":"Foto nicht akzeptiert",
               "hu":"A fotó nem elfogadott",
               "nl":"Foto niet geaccepteerd",
               "fr":"Photo non acceptée",
               "es":"Foto no aceptada"
            },
            "Unfortunately, we could not accept your photo.": {
               "en":"Unfortunately, we could not accept your photo.",
               "de":"Leider konnten wir Ihr Foto nicht akzeptieren.",
               "hu":"Sajnos nem tudtuk elfogadni a fotódat.",
               "nl":"Helaas konden we je foto niet accepteren.",
               "fr":"Malheureusement, nous n'avons pas pu accepter votre photo.",
               "es":"Desafortunadamente, no pudimos aceptar tu foto."
            },
            "I accept the ": {
               "en":"I accept the ",
               "de":"Ich akzeptiere die ",
               "hu":"Elfogadom a ",
               "nl":"Ik accepteer de ",
               "fr":"J'accepte les ",
               "es":"Acepto los "
            },
            "Terms and Conditions.": {
               "en":"Terms and Conditions.",
               "de":"Allgemeinen Geschäftsbedingungen.",
               "hu":"Felhasználási feltételeket.",
               "nl":"Algemene Voorwaarden.",
               "fr":"Conditions Générales.",
               "es":"Términos y Condiciones."
            }, "I am ready to start!": {
               "en":"I am ready to start!",
               "de":"Ich bin bereit zu starten!",
               "hu":"Készen állok a kezdésre!",
               "nl":"Ik ben klaar om te beginnen!",
               "fr":"Je suis prêt à commencer!",
               "es":"¡Estoy listo para empezar!"
            }


            
            
            

         
   
  };

  constructor() {}

  getTrans(trans) {
    try {
      if (this.translations[trans] && this.translations[trans][this.locale]) {
        return this.translations[trans][this.locale];
      } else {
        return this.translations[trans]['en'];
      }
    } catch {
      console.log('error', trans);
    }
  }
}
